import React, { useEffect, useRef, useState } from "react";
import "./App.css";

function BtsVideo({ videoId, movies, trailers = [] }) {
  // If a videoId is provided, find the corresponding movie
  const selectedMovie = videoId ? movies.find(movie => movie.id === parseInt(videoId)) : movies[0];
  const initialIndex = videoId ? movies.findIndex(movie => movie.id === parseInt(videoId)) : 0;

  const [currentIndex, setCurrentIndex] = useState(initialIndex >= 0 ? initialIndex : 0);
  const videoRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const index = Number(entry.target.dataset.index);
          if (entry.isIntersecting) {
            setCurrentIndex(index);
            // Play current video
            videoRefs.current.forEach((vid, i) => {
              if (vid) {
                if (i === index) vid.play().catch(() => { });
                else {
                  vid.pause();
                  vid.currentTime = 0;
                }
              }
            });
          }
        });
      },
      { threshold: 0.6 }
    );

    const items = document.querySelectorAll(".bts-reel-item");
    items.forEach((item) => observer.observe(item));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="bts-video-wrapper">
      {/* Header */}
      <div className="bts-header">
        <h1 className="bts-title">BTS Projects</h1>
        <div className="bts-toggle">
          <button className="toggle-btn active">Video</button>
        </div>
      </div>

      {/* Main Section */}
      <div className="bts-main">
        {/* Left Info (sticky) */}
        <div className="bts-info">
          {movies.length > 0 && (
            <>
              <h2 className="movie-name">{selectedMovie ? selectedMovie.title : movies[currentIndex].title}</h2>
              <p className="movie-description">
                {selectedMovie ? selectedMovie.description : movies[currentIndex].description}
              </p>
            </>
          )}
        </div>

        {/* Right Scroll Reels */}
        <div className="bts-reel-frame">
          <div className="bts-reel-scroll">
            {movies.map((movie, index) => (
              <div
                key={movie.id}
                className="bts-reel-item"
                data-index={index}
              >
                <video
                  ref={(el) => (videoRefs.current[index] = el)}
                  muted
                  playsInline
                  loop
                  preload="auto"
                  controls
                >
                  <source src={movie.videoUrl} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default BtsVideo;